import {
  type Breadcrumb,
  Breadcrumbs,
} from '@pm/ui/src/components/Layout/Breadcrumbs/Breadcrumbs';
import { useLocationReturnTo } from '../../hooks/use-location-return-to/use-location-return-to';
import { BackArrow } from '../BackArrow';

export function RouteLayoutWithBackLink({
  backTo = '..',
  breadcrumbs = null,
  children,
}: {
  backTo?: string;
  breadcrumbs?: Breadcrumb[] | null;
  children?: React.ReactNode;
}) {
  const to = useLocationReturnTo({ fallback: backTo });

  return (
    <div className="flex flex-col space-y-5">
      <BackArrow lastPath={to} />
      {breadcrumbs && breadcrumbs.length > 0 && (
        <Breadcrumbs crumbs={breadcrumbs} />
      )}
      {children}
    </div>
  );
}
